import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {Department} from "@etop/models";
import {DepartmentStore, StateDepartment} from "./department.store";

@Injectable({
  providedIn: 'root'
})
export class DepartmentQuery extends QueryEntity<StateDepartment, Department> {
  constructor(protected store: DepartmentStore) {
    super(store);
  }

  get Ui() {
    return this.getValue().ui;
  }
}
